<template>
  <v-card>
    <v-card-title class="d-flex align-center">
      <h1 class="text-2xl font-weight-semibold">
        <v-icon
          size="24"
          @click="goToSchedulesHome"
        >
          {{ icons.mdiKeyboardBackspace }}
        </v-icon>
        {{ hospital.name }} - {{ department.name }}
      </h1>
      <v-spacer></v-spacer>
      <v-btn
        color="error"
        @click="goToApprovals"
      >
        {{ $t('button.approvals') }}
      </v-btn>
      <v-menu
        offset-y
        open-on-hover
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            color="primary ml-3 px-15"
            v-bind="attrs"
            v-on="on"
          >
            {{ $t('button.options') }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item link>
            <v-list-item-title @click.stop="shareDialog = true">
              {{ $t('button.shareVacancies') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item link>
            <v-list-item-title @click="sidebarRemoteCall('createVacancy')">
              {{ $t('button.createVacancy') }}
            </v-list-item-title>
          </v-list-item>
          <!--
            <v-list-item link>
              <v-list-item-title @click="sidebarRemoteCall('sidebarCopySchedule')">
                {{ $t('button.copySchedule') }}
              </v-list-item-title>
            </v-list-item>
          -->
        </v-list>
      </v-menu>
    </v-card-title>
    <v-card-text>
      <div class="mb-3 text-subtitle-1">
        {{ subtitle }}
      </div>
      <calendar
        v-if="hospital.id"
        :key="`calendar-key-${calendarKey}`"
        :hospital-id="hospital.id"
        :department-id="department.id"
        :activity-id="activity.id"
      />
    </v-card-text>
    <sidebar-form ref="createVacancy">
      <template v-slot:header>
        {{ $t('button.createVacancy') }}
      </template>
      <template v-slot:content="{closeFn}">
        <create-vacancy-form
          :place-id="hospital.id"
          :department-id="department.id"
          :activity-id="activity.id"
          :close="closeFn"
          @on-change="reloadCalendar"
        />
      </template>
    </sidebar-form>
    <sidebar-form ref="sidebarCopySchedule">
      <template v-slot:header>
        {{ $t('button.copySchedule') }}
      </template>
      <template v-slot:content="{closeFn}">
        <copy-schedule-form
          :close="closeFn"
          @on-change="noop"
        />
      </template>
    </sidebar-form>
    <v-dialog
      v-model="shareDialog"
      max-width="420"
    >
      <v-card>
        <v-card-title class="text-h5">
          Compartilhar vaga(s)
        </v-card-title>
        <v-card-text>
          Envie uma notificação para os plantonistas cadastrados, ou copie e cole o link de compartilhamento para enviar por e-mail ou WhatsApp.
          <v-btn
            block
            outlined
            color="success"
            class="mt-8 my-3"
            @click="noop"
          >
            <v-icon size="24">
              mdi-content-copy
            </v-icon>
            Copiar link de compartilhamento
          </v-btn>
          <v-btn
            block
            color="primary"
            class="mb-3"
            @click="noop"
          >
            Enviar notificação
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style scoped>
  .text-subtitle-1 {
    padding-left: 0.2rem;
    font-size: 0.9rem !important;
    margin-top: -1rem !important;
    margin-bottom: 2.2rem !important;
  }
</style>

<script>
import { mdiKeyboardBackspace } from '@mdi/js';

import SidebarForm from '@/components/SidebarForm.vue';
import Calendar from '@/components/Calendar.vue';
import CopyScheduleForm from './CopyScheduleForm.vue';
import CreateVacancyForm from './CreateVacancyForm.vue';

export default {
  components: {
    Calendar,
    SidebarForm,
    CopyScheduleForm,
    CreateVacancyForm,
  },

  data() {
    return {
      subtitle: this.$t('pages.schedulesViewSubtitle'),
      hospital: {},
      department: {},
      activity: {},
      shareDialog: false,
      sidebar: { show: false },
      calendarKey: 0,

      icons: {
        mdiKeyboardBackspace,
      },
    };
  },

  async mounted() {
    await this.fillHospitalAndDepartment();
  },

  methods: {
    async fillHospitalAndDepartment() {
      let hospital;

      try {
        hospital = (
          await this.$api.hospital.getHospital(this.$route.params.hospitalId)
        ).data;
      } catch (error) {
        this.$store.dispatch('NOTIFICATION_ERROR', error.message);

        return;
      }

      this.hospital = hospital;
      this.department = this.hospital.departments.find(((department) => department.id === this.$route.params.departmentId));
      this.activity = this.department.activities.shift();
    },

    sidebarRemoteCall(componentName) {
      this.$refs[componentName].$el.click();
    },

    goToSchedulesHome() {
      this.$router.push('/schedules');
    },

    goToApprovals() {
      this.$router.push(`/schedules/${this.$route.params.hospitalId}/${this.$route.params.departmentId}/approvals`);
    },

    reloadCalendar() {
      this.calendarKey += 1;
    },

    noop() {
      return null;
    },
  },
};
</script>
